var windowWidth,lazyImages,lazyBackground,lazyIframe,lazyScripts,src,style,datasrc,urls,analytics,s,x,i,j,flag;
document.addEventListener("DOMContentLoaded", function() {
	windowWidth = screen.width;
	lazyImages = document.querySelectorAll('img.lazy');
	nolazyImages = document.querySelectorAll('img.lazy2');
	lazyBackground = document.querySelectorAll('.lazybg');
	lazyIframe = document.querySelectorAll('iframe.lazy');
	lazyScripts = document.getElementsByTagName("script");
	i=0;
	j=0;
	flag=1;

	lazyLoadImg2();

	window.addEventListener("scroll", function() {
		init();
	});
	window.addEventListener("mousemove", function() {
		init();
	});
	window.addEventListener("touchstart", function() {
		init();
	});
	setTimeout(function() {
		init();
	}, 6000);
});
function init() {
	if(flag) {
		flag=0;
		lazyLoadImg();
		lazyLoadBackground();
		lazyLoadIframe();
		load_all_js();
	}
}
function lazyLoadImg() {
	lazyImages.forEach(function(elem) {
		if( windowWidth < 600 )
			src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src2 : elem.dataset.mobsrc;
		else
			src = elem.dataset.src2;

		if( src != null )
			elem.src = src;

		elem.classList.remove("lazy");
	});
}
function lazyLoadImg2() {
	if( windowWidth < 600 ) {
		lazyImages.forEach(function(elem) {
			src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;

			if( src != null )
				elem.src = src;
		});
	}
}
function lazyLoadBackground() {
	lazyBackground.forEach(function(elem) {
		if( windowWidth < 600 )
			lazybg = (elem.dataset.moblazybg == undefined) ? elem.dataset.lazybg : elem.dataset.moblazybg;
		else
			lazybg = elem.dataset.lazybg;

		if( lazybg != null )
			elem.style = lazybg;
	});
}
function lazyLoadIframe() {
	lazyIframe.forEach(function(elem) {
		elem.src = elem.dataset.src;
	});
}
function lazyLoadScripts() {
	if (j == lazyScripts.length)
		return;

	if ( lazyScripts[j].getAttribute("type") == "lazyload2" ) {
		lazyScripts[j].setAttribute("type", "lazyloaded");
		if (typeof lazyScripts[j].dataset.src !== 'undefined') {
			s=document.createElement("script");
			s.type="text/javascript";
			s.async=!0;
			s.src=lazyScripts[j].dataset.src;
			x=document.getElementsByTagName("body")[0];
			x.appendChild(s);
			s.onload=function() {
				j++;
				lazyLoadScripts();
			};
		} else {
			s=document.createElement("script");
			s.type="text/javascript";
			s.async=!0;
			s.innerHTML=lazyScripts[j].innerHTML;
			x=document.getElementsByTagName("body")[0];
			x.appendChild(s);
			j++;
			lazyLoadScripts();
		}
	} else {
		j++;
		lazyLoadScripts();
	}
}
function lazyLoadCss(url) {
	s=document.createElement("link");
	s.rel="stylesheet";
	s.href=url;
	x=document.getElementsByTagName("head")[0];
	x.appendChild(s);
}
function lazyLoadJS(url) {
	s=document.createElement("script");
	s.type="text/javascript";
	s.async=!0;
	s.src=url;
	x=document.getElementsByTagName("body")[0];
	x.appendChild(s);
}
function asyncLoad() {
	var urls = [

		"https://scripttags.jst.ai/shopify_justuno_1953230_7070e310-8e47-11ea-96b6-3d1220a8463d.js?shop=nanoblock.myshopify.com",
		"https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=YfsfwH&shop=nanoblock.myshopify.com",
	];

	for (i = 0; i < urls.length; i++) {
		s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = urls[i];
		x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	}
}
function load_all_js() {
	lazyLoadCss("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
	lazyLoadCss();
	lazyLoadCss("//nanoblock.com.au/cdn/shop/t/54/assets/sca-quick-view.css?v=137430769807432326481790123790");
	lazyLoadCss("//nanoblock.com.au/cdn/shop/t/54/assets/sca-jquery.fancybox.css?v=152214158924873746481790123790");
	lazyLoadCss("//nanoblock.com.au/cdn/shop/t/54/assets/bold-upsell.css?v=51915886505602322711790123792");
	lazyLoadCss("//nanoblock.com.au/cdn/shop/t/54/assets/bold-upsell-custom.css?v=150135899998303055901790123791");
	lazyLoadCss("https://limespot.azureedge.net/storefront/2.0.0/css/recommendations.min.css");
	lazyLoadCss("https://limespot.azureedge.net/storefront/2.0.0/css/shopify/canopy-theme.min.css");

	asyncLoad();

	analytics = document.getElementsByClassName("analytics");
	s=document.createElement("script");
	s.type="text/javascript";
	s.innerHTML=analytics[0].innerHTML;
	x=document.getElementsByTagName("body")[0];
	x.appendChild(s);

	j=0;
	lazyLoadScripts();

	setInterval(function() {
		lazyImages = document.querySelectorAll('img.lazy');
		lazyLoadImg();
	}, 3000)
}
